module.exports = __webpack_public_path__ + "a9a7d052da70241a223846d4a293af05.svg";